import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

import {CustomValidators} from '../../core/validator/custom-validators';
import {ValidatorService} from '../../core/validator/validator.service';

@Component({
  selector: 'app-dialog-work-time-range-delete',
  templateUrl: './dialog.work-time-range-delete.component.html'
})
export class DialogWorkTimeRangeDeleteComponent implements OnInit, OnDestroy {
  deleteWorkTimeRangeDetailsForm: FormGroup;
  formReason: string;

  @Output() deleteWorkTimeRangeEvent = new EventEmitter<string>();
  @Output() closeEmitter = new EventEmitter();

  constructor(public activeModal: NgbActiveModal,
              private validatorService: ValidatorService) {
  }

  ngOnInit() {
    this.createWorkTimeRangeDeleteForm();
  }

  ngOnDestroy() {
    this.closeEmitter.emit();
  }

  private createWorkTimeRangeDeleteForm(): void {
    this.deleteWorkTimeRangeDetailsForm = new FormGroup({
      'reason': new FormControl('', CustomValidators.notEmpty),
    });
  }

  onDelete() {
    if (this.validatorService.isValidFormGroup(this.deleteWorkTimeRangeDetailsForm)) {
      this.deleteWorkTimeRangeEvent.emit(this.formReason);
      this.activeModal.close(true);
    }
  }

  onClose() {
    this.closeEmitter.emit();
    this.activeModal.close(false);
  }

  dismiss(s: string) {
    this.closeEmitter.emit();
    this.activeModal.dismiss(s);
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/ecv-project/dialog/dialog.work-time-range-delete.component.ts